import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <header className='header'>
        <div className="container header__container">
            <div className="content">
                <h2>Corelink Computer Institute</h2>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam alias veritatis Lorem ipsum dolor sit amet, consectetur adipisicing.  officiis! Esse facere tempore sapiente dolor itaque? Esse, beatae.
                </p>
                <button className="btn">
                    Visit Us To Know More
                </button>
            </div>
        </div>
        
    </header>
  )
}

export default Header